// (c) 2026 Owl Consultations. All rights reserved.
// Proprietary and confidential — licensed use only.
//
// D-POT-2 — the global overlays of the standalone ASP POT app (spec §0.5), mounted once by the
// shell: `<PotOverlays />` renders the privacy ribbon, the announcement pop-ups, the feedback
// button and the modal.js-style toast stack. Each component is self-contained (no props). The
// legal footer is already part of PotShell.
import { createElement, Fragment } from 'react'
import PrivacyBanner from './PrivacyBanner'
import Announcements from './Announcements'
import FeedbackWidget from './FeedbackWidget'
import PotToasts, { showPotAlert, type PotAlertType } from './PotToasts'

export { PrivacyBanner, Announcements, FeedbackWidget, PotToasts, showPotAlert }
export type { PotAlertType }

export function PotOverlays() {
  return createElement(Fragment, null,
    createElement(PrivacyBanner),
    createElement(Announcements),
    createElement(FeedbackWidget),
    createElement(PotToasts),
  )
}
